import { styled } from '@material-ui/core/styles'

import { TrackButton } from 'artkive/components/Tracker'

export const ImageWrapButton = styled(TrackButton)({
  display: 'block',
  position: 'relative',
  zIndex: 1,
  maxWidth: '100%',
  minWidth: 'auto',
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& > img': {
    borderRadius: '4px',
  },
})

export const TextWrap = styled('div')(({ theme }) => ({
  marginTop: '32px',
  margin: '32px 0 24px 0',
  // TODO use typographyClasses when migrate mui to v5
  ['& .MuiTypography-h3']: {
    marginBottom: '16px',
    textAlign: 'center',
  },
  [theme.breakpoints.up('md')]: {
    margin: '24px 8px',

    // TODO use typographyClasses when migrate mui to v5
    ['& .MuiTypography-h3']: {
      marginBottom: '24px',
    },
  },
  [theme.breakpoints.up('lg')]: {
    margin: '32px 16px',
  },
  [theme.breakpoints.up('xl')]: {
    margin: '32px 54px 40px',
  },
}))

export const LearnMoreButtonLink = styled(TrackButton)(({ theme }) => ({
  display: 'flex',
  width: '220px',
  paddingTop: '12px',
  paddingBottom: '12px',
  borderWidth: '1px',
  borderColor: theme.colors.sky[500],
  margin: 'auto',
  marginBottom: 0,
}))
